export default "__VITE_ASSET__D3ESqOs9__"